import {
	FILTER_ID as WORKOUT_DURATION_FILTER_ID,
	FILTER_LABELS as WORKOUT_DURATION_FILTER_LABELS,
	filterForDuration,
} from './workout/duration';

import {
	FILTER_ID as WORKOUT_INTENSITY_FILTER_ID,
	FILTER_LABELS as WORKOUT_INTENSITY_FILTER_LABELS,
	FILTER_RADIO_LABELS as WORKOUT_INTENSITY_FILTER_RADIO_LABELS,
	filterForIntensity,
} from './workout/intensity';

import {
	FILTER_ID as WORKOUT_TRAINING_GOAL_FILTER_ID,
	FILTER_LABELS as WORKOUT_TRAINING_GOAL_FILTER_LABELS,
	filterForTrainingGoal,
} from './workout/trainingGoal';

import {
	FILTER_ID as RECIPE_ALLERGIES_FILTER_ID,
	FILTER_LABELS as RECIPE_ALLERGIES_FILTER_LABELS,
	filterForAllergies,
} from './recipe/allergies';

import {
	FILTER_ID as RECIPE_CALORIES_FILTER_ID,
	FILTER_LABELS as RECIPE_CALORIES_FILTER_LABELS,
	filterForCalories,
} from './recipe/calories';

import {
	FILTER_ID as RECIPE_DIET_FORM_FILTER_ID,
	FILTER_LABELS as RECIPE_DIET_FORM_FILTER_LABELS,
	filterForDietForm,
} from './recipe/dietForm';

import {
	FILTER_ID as RECIPE_DURATION_FILTER_ID,
	FILTER_LABELS as RECIPE_DURATION_FILTER_LABELS,
	filterForDuration as filterForCookingDuration,
} from './recipe/duration';

import {
	FILTER_ID as RECIPE_MENU_TYPE_FORM_FILTER_ID,
	FILTER_LABELS as RECIPE_MENU_TYPE_FORM_FILTER_LABELS,
	filterForMenuType,
} from './recipe/menuType';

import {
	FILTER_ID as RECIPE_TOGO_FILTER_ID,
	FILTER_LABELS as RECIPE_TOGO_FILTER_LABELS,
	filterForTogo,
} from './recipe/togo';

export const ALL_FILTERS_MAP = {
	WORKOUT_DURATION_FILTER_ID,
	WORKOUT_INTENSITY_FILTER_ID,
	WORKOUT_TRAINING_GOAL_FILTER_ID,
	RECIPE_ALLERGIES_FILTER_ID,
	RECIPE_CALORIES_FILTER_ID,
	RECIPE_DIET_FORM_FILTER_ID,
	RECIPE_DURATION_FILTER_ID,
	RECIPE_MENU_TYPE_FORM_FILTER_ID,
	RECIPE_TOGO_FILTER_ID,
};

type ValueOf<T> = T[keyof T];
export type ALL_FILTER_IDS = ValueOf<typeof ALL_FILTERS_MAP>;

export {
	WORKOUT_DURATION_FILTER_ID,
	WORKOUT_INTENSITY_FILTER_ID,
	WORKOUT_TRAINING_GOAL_FILTER_ID,
	RECIPE_ALLERGIES_FILTER_ID,
	RECIPE_CALORIES_FILTER_ID,
	RECIPE_DIET_FORM_FILTER_ID,
	RECIPE_DURATION_FILTER_ID,
	RECIPE_MENU_TYPE_FORM_FILTER_ID,
	RECIPE_TOGO_FILTER_ID,
};

export const ALL_FILTERS = {
	[WORKOUT_DURATION_FILTER_ID]: {
		id: WORKOUT_DURATION_FILTER_ID,
		labels: WORKOUT_DURATION_FILTER_LABELS,
		filter: filterForDuration,
	},
	[WORKOUT_INTENSITY_FILTER_ID]: {
		id: WORKOUT_INTENSITY_FILTER_ID,
		labels: WORKOUT_INTENSITY_FILTER_LABELS,
		filter: filterForIntensity,
		radioLabels: WORKOUT_INTENSITY_FILTER_RADIO_LABELS,
	},
	[WORKOUT_TRAINING_GOAL_FILTER_ID]: {
		id: WORKOUT_TRAINING_GOAL_FILTER_ID,
		labels: WORKOUT_TRAINING_GOAL_FILTER_LABELS,
		filter: filterForTrainingGoal,
	},

	[RECIPE_ALLERGIES_FILTER_ID]: {
		id: RECIPE_ALLERGIES_FILTER_ID,
		labels: RECIPE_ALLERGIES_FILTER_LABELS,
		filter: filterForAllergies,
	},
	[RECIPE_CALORIES_FILTER_ID]: {
		id: RECIPE_CALORIES_FILTER_ID,
		labels: RECIPE_CALORIES_FILTER_LABELS,
		filter: filterForCalories,
	},
	[RECIPE_DIET_FORM_FILTER_ID]: {
		id: RECIPE_DIET_FORM_FILTER_ID,
		labels: RECIPE_DIET_FORM_FILTER_LABELS,
		filter: filterForDietForm,
	},
	[RECIPE_DURATION_FILTER_ID]: {
		id: RECIPE_DURATION_FILTER_ID,
		labels: RECIPE_DURATION_FILTER_LABELS,
		filter: filterForCookingDuration,
	},
	[RECIPE_MENU_TYPE_FORM_FILTER_ID]: {
		id: RECIPE_MENU_TYPE_FORM_FILTER_ID,
		labels: RECIPE_MENU_TYPE_FORM_FILTER_LABELS,
		filter: filterForMenuType,
	},
	[RECIPE_TOGO_FILTER_ID]: {
		id: RECIPE_TOGO_FILTER_ID,
		labels: RECIPE_TOGO_FILTER_LABELS,
		filter: filterForTogo,
	},
};

export default ALL_FILTERS;
